function generateShortEndpointName(name): string {
  try {
    return name.split('_').reduce((shortName, part) => (shortName += part[0]), '');
  } catch (e) {
    return name;
  }
}

export default function getResourceParamPrefix(vendor, endpointIndex) {
  const endpoint = vendor.endpoints[endpointIndex];
  const isSource = !!endpoint.source_template;
  const middle = `${vendor.name}_${generateShortEndpointName(endpoint.name)}`;
  return isSource ? `rest.iterations.${middle}.` : `url.template.${middle}.`;
}
